import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4836B]';
  const variants = {
    primary: 'bg-[#D4836B] hover:bg-[#C4735B] text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-white border-2 border-[#D4836B] text-[#D4836B] hover:bg-[#FFF5F2]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-115">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-116" />}
    </motion.button>;
}